import * as React from 'react'
import PropTypes from 'prop-types'
import { StepSet } from './screens/Navigation'
import * as Toaster from 'contexts/toaster'
import Screens from './screens'
import * as Context from './contexts/root'

Form.propTypes = {
    values: PropTypes.object, // MIN report data:if editing!
    schemas: PropTypes.shape({
        data: PropTypes.object.isRequired,
        form: PropTypes.object.isRequired,
        display: PropTypes.object.isRequired,
    }).isRequired,
}

export default function Form({ values, schemas }) {
    return (
        <Toaster.Provider>
            <Context.Provider values={values} schemas={schemas}>
                <StepSet />
                <Toaster.Toaster />
                <Screens />
            </Context.Provider>
        </Toaster.Provider>
    )
}
